import { INDEX_INDICATOR_OPTIONS, INDICATOR_FILTER_NAME, LEGACY_INDICATOR_FILTERS } from './index-indicators';
import { KPI_OPTIONS } from './kpi-options';

type WordForm = 'label' | 'headingLabel';

/** Words of the pre-remodel type and index filters (`employed`, `revenue-index`, …), keyed by filter name. */
function legacyFilterWords(form: WordForm): Record<string, Map<string, string>> {
  const words: Record<string, Map<string, string>> = {};

  for (const kpi of KPI_OPTIONS) {
    if (!kpi.legacy) continue;
    (words[kpi.legacy.filterName] ??= new Map()).set(kpi.legacy.value, kpi[form]);
  }

  for (const [metricId, filterName] of Object.entries(LEGACY_INDICATOR_FILTERS)) {
    words[filterName!] = new Map(
      INDEX_INDICATOR_OPTIONS.filter((option) => option.metricId === +metricId).map((option) => [option.value, option[form]]),
    );
  }
  return words;
}

/**
 * Heading words of KPI and indicator filter values, keyed by filter name: the legacy type and index
 * filters that legacy dashboards still use, and the `indicator` filter. The `kpi` filter is not
 * worded: metric profiles read its raw id.
 */
export function kpiFilterHeaderWords(): Record<string, Map<string, string>> {
  return {
    ...legacyFilterWords('headingLabel'),
    [INDICATOR_FILTER_NAME]: new Map(INDEX_INDICATOR_OPTIONS.map((option) => [option.value, option.headingLabel])),
  };
}

/** Nominative labels of the legacy type and index filter values (library titles of old slices). */
export function legacyKpiFilterLabels(): Record<string, Map<string, string>> {
  return legacyFilterWords('label');
}
